export enum ApplicationStateParameterEnum {
  DebugPanelCollapsedImportStatement = "import_statement_debug_collapsed"
}
